<!-- Node -->
<div
  gaCategory="Search Node"
  data-test="treeNode"
  class="tree-node"
  [attr.data-id]="sanitizedID"
  (keyup.enter)="handleNodeClick($event, node)"
  (click)="handleNodeClick($event, node)"
  tabindex="0"
  [ngClass]="{
    'tree-node--light': theme === treeTheme.Light,
    'tree-node--themed': theme === treeTheme.Themed,
    'tree-node--hidden': !node.boolState.shown,
    'tree-node--selected': checked,
    'tree-node--unpickable': !node.boolState.pickable && isLoft
  }">

  <!-- Expander -->
  <div
    appEventFence
    (click)="handleExpandClick(node, node.boolState.expanded)"
    class="tree-node__expand"
    data-test="treeNodeExpand"
    [class.tree-node__expand--open]="node.boolState.expanded"
    *ngIf="nested && hasChildren">

    <app-icon icon="caret-right"></app-icon>
  </div>

  <!-- Label -->
  <div
    class="tree-node__label"
    [ngClass]="{'tree-node__label--padded': !hasChildren && nested}"
    (dblclick)="setEditLabelMode(true)"
    *ngIf="!editLabelMode">

    <div class="flex flex-column">
      <div
        data-test="treeNodeId"
        class="text-10 text-uppercase"
        style="opacity: 0.7;"
        *ngIf="showTreeNodeIds$ | async">
        {{ shortId }}
      </div>
  
      <div data-test="treeNodeLabel">
        {{ node.label }}
      </div>
    </div>

  </div>

  <!-- Edit Object Label -->
  <input
    type="text"
    appEventFence
    appAutoFocus
    data-test="treeNodeEditLabel"
    [value]="node.label"
    (blur)="handleObjectLabel($event)"
    (keyup)="handleObjectLabel($event)"
    class="input"
    *ngIf="editLabelMode">

  <!-- Layer Order -->
  <input
    appEventFence
    type="text"
    data-test="treeNodeLayerOrder"
    [value]="node.numState.layer"
    (change)="handleLayerOrder($event, node)"
    class="input input--small tree-node__layer-order"
    *ngIf="(layerOrderMode$ | async)">

  <!-- Visible -->
  <div
    gaEvent
    gaAction="Clicked Toggle (Eye Icon)"
    [gaLabel]="node.boolState.shown ? 'Hide' : 'Show'"
    data-test="treeNodeVisible"
    class="tree-node__visible"
    (click)="toggleVisible(node)"
    appEventFence>
    <app-icon icon="eye" data-test="treeNodeVisibleTrue" size="xs" class="tree-node__eye"></app-icon>
    <app-icon icon="eye-slash" data-test="treeNodeVisibleFalse" size="xs" class="tree-node__eye-slash"></app-icon>
  </div>

  <app-node-actions eventCategory="Search Node" [theme]="theme" [node]="node" appEventFence></app-node-actions>
</div>